import './Page.css';
import './ContactPage.css';

export default function ContactPage() {
  return (
    <div className="page-wrap">
      <div className="navy-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p className="page-hero-sub">We're here to help</p>
          <p className="contact-hero-desc">
            Book a consultation, ask a question, or find the right program for your child's academic journey.
          </p>
        </div>
      </div>

      <div className="container page-body">

        {/* Consultation Options */}
        <div className="page-section" style = {{marginTop: 32}}>
          <h2 className="section-heading">Book a Consultation</h2>
          <p className="section-sub">Not sure where to start? We offer two ways to get personalized guidance.</p>

          <div className="two-col-section">
            <div className="consult-card">
              <div className="consult-card-tag">New Families</div>
              <h3 className="consult-card-title">Meet the Director</h3>
              <p className="consult-card-desc">
                Start with a <strong>free 15-minute call</strong> to find the right program — no pressure, no commitment. Continue for $15 per additional 15-minute block.
              </p>
              <ul className="check-list consult-list">
                <li>Free 15-Minute Intro Call</li>
                <li>Extended blocks at $15 / 15 min</li>
                <li>Personalized program recommendation</li>
              </ul>
              <a
                href="https://secure.tutorcruncher.com/scholar-sphere/signup/client/"
                target="_blank"
                rel="noreferrer"
                className="btn-gold"
              >
                Book Free Call
              </a>
            </div>

            <div className="consult-card consult-card-featured">
              <div className="consult-card-tag">All Families</div>
              <h3 className="consult-card-title">Talk to Your Tutor</h3>
              <p className="consult-card-desc">
                Connect directly with an expert in your subject — whether it's SAT/ACT prep, AP classes, college essays, or academic coaching.
              </p>
              <ul className="check-list consult-list">
                <li>We match you with the right expert</li>
                <li>30-minute session – $30</li>
                <li>60-minute session – $60</li>
              </ul>
              <a
                href="https://secure.tutorcruncher.com/scholar-sphere/signup/client/"
                target="_blank"
                rel="noreferrer"
                className="btn-navy"
              >
                Request a Tutor
              </a>
            </div>
          </div>
        </div>

        {/* Contact + Community */}
        <div className="page-section contact-bottom-grid">
          <div>
            <h2 className="section-heading">Reach Us Directly</h2>
            <p className="page-p">Have a quick question? Reach out any time.</p>
            <div className="contact-info-list">
              <div className="contact-info-item">
                <span className="contact-info-icon">📧</span>
                <div>
                  <div className="contact-info-label">Email</div>
                  <div className="contact-info-val">contact@scholar-sphere.com</div>
                  <div className="contact-info-note">Response within 24 hours</div>
                </div>
              </div>
              <div className="contact-info-item">
                <span className="contact-info-icon">📞</span>
                <div>
                  <div className="contact-info-label">Phone</div>
                  <div className="contact-info-val">(224) 381-2351</div>
                  <div className="contact-info-val">(224) 413-1336</div>
                </div>
              </div>
              <div className="contact-info-item">
                <span className="contact-info-icon">💬</span>
                <div>
                  <div className="contact-info-label">WhatsApp</div>
                  <div className="contact-info-val">Message us for fast replies</div>
                </div>
              </div>
              <div className="contact-info-item">
                <span className="contact-info-icon">📱</span>
                <div>
                  <div className="contact-info-label">Social Media</div>
                  <div className="contact-info-val">Facebook · Instagram · LinkedIn · YouTube</div>
                </div>
              </div>
            </div>
          </div>

          <div className="community-card">
            <div className="community-icon">💬</div>
            <h3 className="community-title">Join Our WhatsApp Community</h3>
            <p className="community-desc">
              400+ families get daily academic tips, SAT/ACT updates, and exclusive course announcements — all in one place.
            </p>
            <ul className="check-list" style={{ marginBottom: 24 }}>
              <li>Open to Grades 6–12 parents and students</li>
              <li>Daily tips, deadlines, and expert advice</li>
              <li>Exclusive course and workshop updates</li>
            </ul>
            <a href="https://chat.whatsapp.com/CCQeMesdLUuHjkTMyljd4O" className="btn-navy" target="_blank" rel="noopener noreferrer">Join the Group</a>
          </div>
        </div>

        <div className="cta-strip">
          <h3>Ready to Get Started?</h3>
          <a
            href="https://secure.tutorcruncher.com/scholar-sphere/signup/client/"
            target="_blank"
            rel="noreferrer"
            className="btn-gold"
          >
            Book a Free Consultation
          </a>
        </div>

      </div>
    </div>
  );
}
